import { useSelector } from "react-redux";
import { SystemUserGroup } from "src/pages/information-assets/models/system-user-group";
import { RootState } from "src/redux/store";


export function useFetchAllSystemUserGroups(): SystemUserGroup[] {
  const systemUserGroups: SystemUserGroup[] = useSelector(
    (rootState: RootState) => rootState.informationSystemUserGroup.systemUserGroupsPEV.value??[]
  );

  return systemUserGroups.map((systemUserGroup) => new SystemUserGroup(systemUserGroup));
}
